// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3NrgU","tab":"ProcedureTabs_tab__hVR2C"};